<script>
import { gitInfo } from '@src/gitInfo';
export default {
  components: {},
  data() {
    return {
      gitInfo,
      currentYear: new Date().getFullYear(),
    }
  },
  computed: {
    getCompanyInfo: function () {
      let cInfo = this.$store.state.appAuth.companyInfo || null
      if (cInfo && cInfo.primary_color){
        // document.body.style.backgroundColor = cInfo.primary_color;
      }
      return cInfo
    },
    langSelected: {
      get() {
        return this.$store.state.language.language
      },
      set(val) {
        this.$store.commit('language/SET_LANGUAGE', val)
      }
    },
    langFlagSelected: function () {
      return this.$store.state.language.languages.find(x => this.langSelected === x.value).flag
    },
  },
  methods: {
    // playVideo() {
    //   const video = this.$refs.backgroundVideo;
    //   video.play();
    //   video.classList.remove('fadingOut');
    //   video.classList.add('fadingIn')
    //   setTimeout(() => {
    //     video.classList.remove('fadingIn');
    //     video.classList.add('fadingOut')
    //   }, (video.duration / video.playbackRate - 1) * 1000);
    // }
  },
  created(){
    document.body.classList.add('authentication-bg');
    document.body.classList.add('authentication-bg-pattern');
  },
  mounted(){
    this.$nextTick(async () => {
      // console.log("entra al mounted")
      const video = this.$refs.backgroundVideo;
      video.play()
      // video.addEventListener('ended', this.playVideo);
    })
  },
  beforeDestroy() {
    // this.$nextTick(() => {
    //   console.log("entra al beforeDestroy")
    //   const video = this.$refs.backgroundVideo;
    //   video.removeEventListener('ended', this.playVideo);
    // })
  }
}
</script>

<template>
  <div class="account-pages">
    <!-- Traduction options -->
    <div class="flag-language float-right">
      <b-nav-item-dropdown
            right
            class="p-0 flag"
            menu-class="language-dropdown"
          >
        <template slot="button-content">
          <div class="show dropdown-toggle">
            <b-img
              :src="require('@assets/images/flags/'+(langFlagSelected || 'ss')+'.svg')"
              alt="lang-image"
              width="20"
              class="my-1"
            />
            <span class="pro-user-name ml-1">
              <i class="fad fa-chevron-down text-white"></i>
            </span>
          </div>
        </template>
        <b-dropdown-item v-for="(lang, i) in $store.state.language.languages" :key="`Lang${i}`" 
          @click="langSelected = lang.value" class="p-0">
          <img
            :src="require('@assets/images/flags/'+lang.flag+'.svg')"
            width="20"
            class="mr-2 my-0"
          />
          <span>{{ lang.name }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </div>
    <!-- content -->
      <div class="full-container pb-4 pb-md-0">
        <slot />
      </div>
      <div class="video-container">
        <video ref="backgroundVideo" autoplay loop muted playsinline class="fadingIn" :src="require('@assets/videos/video-login.mp4')" type="video/mp4">
          TU navegador no soporta el elemento de video.
        </video>
      </div>
      <footer class="footer footer-alt font-8 text-muted">
        &copy; {{ $t('copyright') }}, {{ currentYear }}, 
        {{ getCompanyInfo && getCompanyInfo.company_name ? getCompanyInfo.company_name : ''}} 
        {{ getCompanyInfo && getCompanyInfo.git_version ? ' | ' + getCompanyInfo.git_version : ''}}
        <p>{{ gitInfo }}</p>
      </footer>
    </div>
</template>

<style lang="scss" scoped>
.flag-language {
  z-index: 1;
  position: absolute;
  top: 2px;
  right: 2px;
  .flag {
    padding: 0.5rem;
    display: inline-flex;
    list-style: none !important;
    img {
      box-shadow: 5px 5px 5px rgba(0,0,0,0.08);
    }
  }
}
.account-pages {
  z-index: 0;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
  min-height: 100vh;

  .video-container {
    top: 0px; 
    right: 0px;
    position: fixed;
    height: 100%;
    width: 100%;
    overflow: hidden;
    video {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      -o-filter: blur(15px);
      filter: blur(15px);
      object-fit: cover;
    }
  }
  .full-container {
    z-index: 2;
    width: 100%;
  }
  @media (max-width: 767px) {
    .video-container {
      position: fixed;
      height: 100%;
      width: 100%;
      overflow: hidden;
      
      video {
        width: auto;
        height: 100%;
        max-width: none;
        position: absolute;
        right: 0;
        left: auto;
      }
    }
  }
  @media (max-aspect-ratio: 16/9) {
    video {
      width: auto;
      height: 100%;
      -o-object-position: right;
      object-position: right;
    }
  }
}
.fadingOut {
  opacity: 0;
  transition: opacity 0.6s ease-out;
}
.fadingIn {
  opacity: 1;
  transition: opacity 0.6s ease-out;
}
</style>